export default __webpack_public_path__ + "static/media/carousel-1.6025da76.png";